<template>
    <div class="freight">
        <div class="biaoti-jiachu" style="margin-bottom:10px">请选择运费方案</div>
        <div>
            <div class="select-item" :class="index == 'customerSelfDelivery' ? 'select' : ''" @click="change('customerSelfDelivery')">
                <div class="circle">
                    <div class="little-circle"></div>
                </div>
                <div class="centre">
                    客户自提
                    <div class="message" v-if="index == 'customerSelfDelivery'">{{ data.tips }}</div>
                </div>
                <div class="price">¥0</div>
            </div>
            <div class="select-item" :class="index == 'roadTransport' ? 'select' : ''" @click="change('roadTransport')">
                <div class="circle">
                    <div class="little-circle"></div>
                </div>
                <div class="centre">
                    科隆送货
                    <a-popover placement="right" v-if="falg2 ? data.roadTransportNormal.message : data.roadTransportLimit.message">
                        <template slot="content">
                            <div>{{ falg2 ? data.roadTransportNormal.message : data.roadTransportLimit.message }}</div>
                        </template>
                        <a-icon type="info-circle" theme="twoTone" two-tone-color="#f00" />
                    </a-popover>
                    <div class="Second-choice" v-if="index == 'roadTransport'">
                        <div class="Second-choice-item" :class="!falg2 ? 'unselect' : ''" @click="falg2 = true">
                            <!-- <a-icon type="check-circle" theme="twoTone" two-tone-color="#2b9a34" v-if="falg2" /> -->
                            <div class="clickSelect" v-if="falg2"><img src="../../assets/checkin_succes@2x .png" alt="" /></div>
                            <div class="circle" v-else></div>
                            <span>
                                正常送
                            </span>
                        </div>
                        <div class="Second-choice-item" :class="falg2 ? 'unselect' : ''" @click="falg2 = false">
                            <!-- <a-icon type="check-circle" theme="twoTone" two-tone-color="#2b9a34" v-if="!falg2" /> -->
                            <div class="clickSelect" v-if="!falg2"><img src="../../assets/checkin_succes@2x .png" alt="" /></div>
                            <div class="circle" v-else></div>
                            <span>
                                限时达
                            </span>
                        </div>
                    </div>
                    <div class="message" v-if="index == 'roadTransport'">{{ falg2 ? data.roadTransportNormal.info : data.roadTransportLimit.info }}</div>
                </div>
                <div class="price">¥{{ falg2 ? data.roadTransportNormal.amount / 100 : data.roadTransportLimit.amount / 100 }}</div>
            </div>
            <div class="select-item" :class="index == 'expressDelivery' ? 'select' : ''" @click="change('expressDelivery')">
                <div class="circle">
                    <div class="little-circle"></div>
                </div>
                <div class="centre">
                    快递配送
                    <a-popover placement="right" v-if="data.expressDelivery.message">
                        <template slot="content">
                            <div>{{ data.expressDelivery.message }}</div>
                        </template>
                        <a-icon type="info-circle" theme="twoTone" two-tone-color="#f00" />
                    </a-popover>
                    <div class="message" v-if="index == 'expressDelivery'">{{ data.expressDelivery.info }}</div>
                </div>
                <div class="price">¥{{ data.expressDelivery.amount / 100 }}</div>
            </div>
            <div class="select-item" :class="index == 'roadConsignment' ? 'select' : ''" @click="change('roadConsignment')">
                <div class="circle">
                    <div class="little-circle"></div>
                </div>
                <div class="centre">
                    公路托运
                    <a-popover placement="right" v-if="data.roadConsignment.message">
                        <template slot="content">
                            <div>{{ data.roadConsignment.message }}</div>
                        </template>
                        <a-icon type="info-circle" theme="twoTone" two-tone-color="#f00" />
                    </a-popover>
                    <div class="Second-choice" v-if="index == 'roadConsignment'">
                        <div class="Second-choice-item" :class="!chioceDoorFee ? 'unselect' : ''" @click="chioceDoorFee = true">
                            <!-- <a-icon type="check-circle" theme="twoTone" two-tone-color="#2b9a34" v-if="chioceDoorFee" /> -->
                            <div class="clickSelect" v-if="chioceDoorFee"><img src="../../assets/checkin_succes@2x .png" alt="" /></div>
                            <div class="circle" v-else></div>
                            <span>
                                送货上门
                            </span>
                        </div>
                        <div class="Second-choice-item" :class="chioceDoorFee ? 'unselect' : ''" @click="chioceDoorFee = false">
                            <!-- <a-icon type="check-circle" theme="twoTone" two-tone-color="#2b9a34" v-if="!chioceDoorFee" /> -->
                            <div class="clickSelect" v-if="!chioceDoorFee"><img src="../../assets/checkin_succes@2x .png" alt="" /></div>
                            <div class="circle" v-else></div>
                            <span>
                                站点自提
                            </span>
                        </div>
                    </div>
                    <div class="message" v-if="index == 'roadConsignment'">{{ chioceDoorFee ? data.roadConsignment.infoMe : data.roadConsignment.info }}</div>
                </div>
                <div class="price">¥{{ chioceDoorFee ? data.roadConsignment.amount2 / 100 : data.roadConsignment.amount / 100 }}</div>
                <!-- <div class="price">¥{{ data.roadConsignment.amount / 100 }}</div> -->
            </div>
            <div class="select-item" :class="index == 'freightCollect' ? 'select' : ''" @click="change('freightCollect')">
                <div class="circle">
                    <div class="little-circle"></div>
                </div>
                <div class="centre">
                    运费到付
                    <a-popover placement="right" v-if="falg3 ? data.logistics.message : data.expressArrival.message">
                        <template slot="content">
                            <div>{{ falg3 ? data.logistics.message : data.expressArrival.message }}</div>
                        </template>
                        <a-icon type="info-circle" theme="twoTone" two-tone-color="#f00" />
                    </a-popover>
                    <div class="Second-choice" v-if="index == 'freightCollect'">
                        <div class="Second-choice-item" :class="!falg3 ? 'unselect' : ''" @click="falg3 = true">
                            <!-- <a-icon type="check-circle" theme="twoTone" two-tone-color="#2b9a34" v-if="falg3" /> -->
                            <div class="clickSelect" v-if="falg3"><img src="../../assets/checkin_succes@2x .png" alt="" /></div>
                            <div class="circle" v-else></div>
                            <span>
                                物流到付
                            </span>
                        </div>
                        <div class="Second-choice-item" :class="falg3 ? 'unselect' : ''" @click="falg3 = false">
                            <!-- <a-icon type="check-circle" theme="twoTone" two-tone-color="#2b9a34" v-if="!falg3" /> -->
                            <div class="clickSelect" v-if="!falg3"><img src="../../assets/checkin_succes@2x .png" alt="" /></div>
                            <div class="circle" v-else></div>
                            <span>
                                快递到付
                            </span>
                        </div>
                    </div>
                    <div class="message" v-if="index == 'freightCollect'">{{ falg3 ? data.logistics.info : data.expressArrival.info }}</div>
                </div>
                <div class="price">¥{{ falg3 ? data.logistics.amount / 100 : data.expressArrival.amount / 100 }}</div>
            </div>
            <!-- <div class="message">
                {{ data.tips }}
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['addressId'],
    watch: {
        addressId: {
            handler(val) {
                console.log(val, '---------------------');
                if (val != '') {
                    this.eachFreightFree(val);
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            index: '',
            data: {},
            chioceDoorFee: false,
            falg2: false,
            falg3: false
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            // this.eachFreightFree();
        },
        change(key) {
            this.index = key;
            let amount = 0;
            // debugger
            if (this.index != 'customerSelfDelivery') {
                if (this.index == 'roadConsignment') {
                    if (this.chioceDoorFee) {
                        //送货上门
                        amount = this.data.roadConsignment.amount2;
                        key = 'homeDelivery';
                    } else {
                        //站点自提
                        amount = this.data.roadConsignment.amount;
                        key = 'siteSelfDelivery';
                    }
                } else if (this.index == 'roadTransport') {
                    if (!this.falg2) {
                        //限时达
                        amount = this.data.roadTransportLimit.amount;
                        key = 'roadTransportLimit';
                    } else {
                        //正常送
                        amount = this.data.roadTransportNormal.amount;
                        key = 'roadTransportNormal';
                    }
                } else if (this.index == 'freightCollect') {
                    if (this.falg3) {
                        //物流到付
                        amount = this.data.logistics.amount;
                        key = 'logistics';
                    } else {
                        //快递到付
                        amount = this.data.expressArrival.amount;
                        key = 'expressArrival';
                    }
                } else {
                    amount = this.data[key].amount;
                }
            }
            let seletcFreight = {
                amount,
                key
            };
            this.$emit('changeFreight', seletcFreight);
        },
        eachFreightFree(addressId) {
            const getcard = JSON.parse(localStorage.cart_goods_list);
            getcard.forEach(element => {
                element.addressId = addressId;
            });
            this.api
                .eachFreightFree(getcard)
                .then(result => {
                    console.log(result, 'awefwefsadfsdafds');
                    if (result.ok == false) {
                        this.$message.info(result.message);
                    } else {
                        this.data = result.data;
                        if (this.index) {
                            this.change(this.index);
                        }
                    }
                })
                .catch(err => {});
        }
    }
};
</script>

<style lang="less" scoped>
.freight {
    .select-item {
        cursor: default;
        display: flex;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        // width: 300px;
        .centre {
            width: 200px;
            margin: 0 0 10px 15px;
        }
        .clickSelect {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 16px;
            height: 20px;
            margin-right: 2px;
            padding-top: 2px;
            > img {
                width: 16px;
                height: 16px;
            }
        }
        .circle {
            width: 16px;
            height: 16px;
            background: #ffffff;
            border: 1px solid #d9d9d9;
            padding: 3px;
            border-radius: 50%;
            margin: 2px 0;
            // .little-circle {
            //     width: 8px;
            //     height: 8px;
            //     border-radius: 50%;
            //     background: #2b9a34;
            // }
        }
        .price {
            width: 135px;
        }
        .switch {
            cursor: pointer;
        }
    }
    .message {
        // margin-left: 31px;
        width: 700px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f24145;
        line-height: 20px;
    }
    .select {
        color: #2b9a34;
        .circle {
            width: 16px;
            height: 16px;
            background: #ffffff;
            border: 1px solid #2b9a34;
            padding: 3px;
            border-radius: 50%;
            margin: 2px 0;
            .little-circle {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #2b9a34;
            }
        }
    }
}
.biaoti-jiachu {
    font-weight: 600;
    color: #333;
}
.Second-choice {
    display: flex;
    width: 700px;
    &-item {
        display: flex;
        margin-right: 30px;
        align-content: center;
        span {
            margin-left: 3px;
        }
        i {
            font-size: 16px;
            margin: 2px 0;
        }
    }
    .unselect {
        color: #333333;
        .circle {
            border: 1px solid #d9d9d9;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/freight/freight.vue